import { useEffect, type ComponentType } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "@/hooks/useUser";
import LoadingScreen from "@/components/LoadingScreen";
import { InteractionStatus } from "@azure/msal-browser";
import { SESSION_STORAGE_KEYS } from "@/constants/constants";

const withAuth = <T extends object>(WrappedComponent: ComponentType<T>) => {
  return (props: T) => {
    const { inProgress } = useMsal();
    const navigate = useNavigate();
    const { isLoading, data } = useUser();
    const isAuthenticated = useIsAuthenticated();
    const { pathname } = useLocation();

    useEffect(() => {
      if (!isLoading && inProgress === InteractionStatus.None) {
        if (!isAuthenticated) {
          sessionStorage.setItem(SESSION_STORAGE_KEYS.REDIRECT_PATH, pathname);
          navigate("/sso");
        } else if (!data?.id) {
          navigate("/");
        }
      }
    }, [isLoading, inProgress, isAuthenticated, data?.id, navigate]);

    if (isLoading || inProgress !== InteractionStatus.None) {
      return <LoadingScreen />;
    } else if (!isAuthenticated) {
      return null;
    } else {
      return <WrappedComponent {...props} />;
    }
  };
};

export default withAuth;
